export const SCROLL_DURATION = 500;

export const COVER_ID = "homeSection/cover";
export const INFO_ID = "homeSection/info";
export const HOUSING_ID = "homeSection/housing";
export const STORY_ID = "homeSection/story";
export const PHOTOS_ID = "homeSection/photos";
export const CONTACT_ID = "homeSection/contact";
export const BRIDESMAID_ID = "homeSection/bridesmaid";
